'use client';

import Link from 'next/link';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center" dir="rtl">
      <div className="text-center">
        <div className="w-20 h-20 rounded-2xl teal-gradient flex items-center justify-center mx-auto mb-6">
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
            <path d="M20 2L36 11V29L20 38L4 29V11L20 2Z" fill="rgba(255,255,255,0.2)" />
            <path d="M13 27V13L20 22V13M20 22V27M27 13V27" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            <circle cx="27" cy="13" r="2.5" fill="#C9A84C" />
          </svg>
        </div>
        <h1 className="text-6xl font-bold text-primary mb-4">404</h1>
        <h2 className="text-xl font-bold text-foreground mb-2">الصفحة غير موجودة</h2>
        <p className="text-muted-foreground mb-6">لم نتمكن من العثور على الصفحة التي تبحث عنها</p>
        <Link
          href="/"
          className="inline-flex items-center gap-2 h-10 px-6 teal-gradient text-white rounded-xl text-sm font-bold hover:opacity-90 transition-opacity"
        >
          العودة للرئيسية
        </Link>
      </div>
    </div>
  );
}